
import { useEffect } from 'react';

export function useDocumentTitle(timeLeft: number, timerType: string) {
  useEffect(() => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    
    const timerTitle = timerType === 'pomodoro' ? 'Pomodoro' : 
                     timerType === 'shortBreak' ? 'Short Break' : 'Long Break';
    
    document.title = `${formattedTime} - ${timerTitle} | Pomodoro Timer`;
    
    return () => {
      document.title = 'Pomodoro Timer';
    };
  }, [timeLeft, timerType]);
}
